import EuroIcon from "@mui/icons-material/Euro";

import NumberTextField from "./NumberTextField";

type EuroTextFieldProps = {
	value: number | null | undefined;
	setValue?: (value: number | null | undefined) => void;
	label?: string;
	errors?: Record<string, boolean | object | string>;
	setErrors?: (value: Record<string, string>) => void;
	integer?: boolean;
	minValue?: number;
	maxValue?: number;
	flat?: boolean;
	readOnly?: boolean;
	isLoaded?: boolean;
	canNotBeValues?: string[];
	notGrey?: boolean;
	negativeAllowed?: boolean;
	allowNull?: boolean;
	nullPlaceholder?: string;
	onFocus?: () => void;
	onBlur?: () => void;
	iconBackground?: string;
	ref?: React.Ref<{
		validate: () => Promise<Record<string, boolean | object | string>>;
	}>;
};

const EuroTextField: React.FC<EuroTextFieldProps> = (props) => (
	<NumberTextField
		{...props}
		icon={<EuroIcon />}
		iconBackground={props.iconBackground ?? "#1a455c"}
		decimalPlaces={2}
	/>
);

export default EuroTextField;
